
// export const BACK_URL = 'http://localhost:3000';
//export const BACK_URL = "https://backpf-production.up.railway.app";
export const BACK_URL = "https://back-pf.vercel.app";
export const FRONT_URL = "https://front-wheat-gamma.vercel.app";
//  export const FRONT_URL = "http://localhost:3000";


